export { default as Discord } from "./discord.svg";
export { default as checkAlt } from "./check-alt.svg";
export { default as Gift } from "./gift.svg";
export { default as Google } from "./google.svg";
export { default as Spinner } from "./spinner.svg";
export { default as Twitter } from "./twitter.svg";
export { default as Copy } from "./Copy.svg";
export { default as BearButter } from "./bearButter.svg";
